import { render, staticRenderFns } from "./RequestServiceCancel.vue?vue&type=template&id=ddce11a2&scoped=true"
import script from "./RequestServiceCancel.vue?vue&type=script&lang=js"
export * from "./RequestServiceCancel.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceCancel.vue?vue&type=style&index=0&id=ddce11a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddce11a2",
  null
  
)

export default component.exports